function MarkdownTextField($parse, $translate, $timeout) {
	return {
		bindToController: {
			field: '<',
            object: '=fieldObject',
            atwho: '<',
		},
		restrict: 'A',
        require:  'ngModel',
        link: function(scope, element, attrs, ngModel) {
          var options = scope.$eval(attrs.markdownTextField) || {};

          scope.undo = [];
          scope.lastContent = "";
          scope.editor = null;
          
          // make button reflect undow state
          var updateUndoButton = function(){
            element.closest('.md-editor').
                find('button[data-handler="bootstrap-markdown-cmdUndo"]').
                toggleClass('disabled', scope.undo.length == 0 || scope.undo.length == 1 && scope.undo[0] == scope.editor.getContent() );
            }
          
            // update undo after blur or othe content change
            // also updates the button
          var updateUndo = function() {
              if (!scope.editor) return;
              var content = scope.editor.getContent();
              if (scope.undo.length == 0) {
                  scope.undo.push(content);
              } else {
                  var lastUndo = scope.undo[scope.undo.length - 1];
                  var push = false;
                  //if (Math.abs(content.length - lastContent.lenght) > 5) push = true;
                  //if (Math.abs(content.length - lastUndo.lenght) > 50) push = true;
                  if (content.trim() != lastUndo.trim()) push = true;
                  if (push) scope.undo.push(content);
              }
              lastContent = content;
              updateUndoButton();
          }
          
          var updatePreview = function(e){
              var html = e.parseContent();
              if (html == '') {
                  element.closest('.md-editor').find('.twitter-footer').show().html(html)
              } else {
                  element.closest('.md-editor').find('.twitter-footer').show().html(html)
              }
          };

            var makeCallback = function(source, additionalCallback) {
                var callback = $parse(source);
                return function(editorObject) {
                    if (additionalCallback) additionalCallback(editorObject);
                    return callback({editorObject: editorObject});
                }
            }

            // Only initialize the $.markdown plugin once.
            if (! element.hasClass('processed')) {
                element.addClass('processed');

                // Setup the markdown WYSIWYG.
                element.markdown({
                  autofocus: options.autofocus || false,
                  saveable: options.saveable || false,
                  iconlibrary: options.iconlibrary || 'glyph',
                  hideable: options.hideable || false,
                  width: options.width || 'inherit',
                  height: options.height || 'inherit',
                  resize: options.resize || 'vertical',
                  language: options.language || $translate.use().substring(0,2),
                  footer: options.footer || '<div class="twitter-footer" style="display:none;"></div>',
                  fullscreen: options.fullscreen || { enable: true, icons: {}},
                  hiddenButtons: options.hiddenButtons || 'cmdPreview',
                  disabledButtons: options.disabledButtons || [],
                  initialstate: options.initialstate || 'editor',
                  parser: options.parser || null,
                  dropZoneOptions: options.dropZoneOptions || null,
                  enableDropDataUri: options.enableDropDataUri || false,
                  showButtons: options.showButtons || null,
                  additionalButtons: [
				    [{
				          name: "groupUndo",
				          data: [{
				            name: "cmdUndo",
				            toggle: false, // this param only take effect if you load bootstrap.js
				            title: "Cofnij",
				            icon: "fa fa-undo",
				            callback: function(e){
				            	var restoredContent = "";
				            	while (scope.undo.length > 0) {
				            		restoredContent = scope.undo.pop();
				            		console.debug(restoredContent);
				            		if (e.getContent().trim() != restoredContent.trim()) {
				            			e.setContent(restoredContent);
				            			break;
				            		}
				            	}
				            	if (scope.undo.length == 0) scope.undo.push(restoredContent);
                                updateUndoButton(e);
                                updatePreview(e);
				            }
				          }]
				    }]
  				  ],

                  //-- Events/Hooks --
                  // each of them are defined as callback available in the directive
                  // example: <textarea markdown-editor="{'iconlibrary': 'fa'}" on-fullscreen-exit="vm.exitFullScreenCallback()"></textarea>
                  //  NOTE: If you want this one to work, you will have to manually download the JS file, not sure why but they haven't released any versions in a while
                  //       https://github.com/toopay/bootstrap-markdown/tree/master/js
                  onPreview: makeCallback(attrs.onPreview),
                  onPreviewEnd: makeCallback(attrs.onPreviewEnd),
                  onSave: makeCallback(attrs.onSave),
                  onBlur: makeCallback(attrs.onBlur, updateUndo),
                  onFocus: makeCallback(attrs.onFocus, updateUndo),
                  onFullscreen: makeCallback(attrs.onFullscreen),
                  onSelect: makeCallback(attrs.onSelect),
                  onFullscreenExit: makeCallback(attrs.onFullscreenExit),
                  onChange: makeCallback(attrs.onChange, function(e) {
                    // When a change occurs, we need to update scope in case the user clicked one of the plugin buttons
                    // (which isn't the same as a keydown event that angular would listen for).
                    ngModel.$setViewValue(e.getContent());

                    updatePreview(e);
                  }),
                  onShow: makeCallback(attrs.onShow, function (e) {
                    // keep the Markdown Object in $rootScope so that it's available also from anywhere (like in the parent controller)
                    // we will keep this in an object under the ngModel name so that it also works having multiple editor in same controller
                    //$rootScope.markdownEditorObjects = $rootScope.markdownEditorObjects || {};
                    //$rootScope.markdownEditorObjects[ngModel.$name] = e;

                    scope.editor = e;
                    scope.$widget.editor = e;
                    updateUndoButton(e);
                    $timeout(function(){
                        updatePreview(e);
                    }, 100);

                    /*element.atwho({
                        at: "@",
                        data: ["one", "two", "three"],
                    }).atwho({
                        at: "{",
                        data: ["one", "two", "three"],
                        insertTpl: "{{${name}}}",
                    });*/
                    

                  })
                });
            }
            
            element.on('keypress', function(e) {
				var code = e.keyCode || e.which;
			    if (code == 13 || code == 0) {
			        // unprintable code
			        updateUndo();
			    }
            });
            

            
        },
        controller: function($element, $scope) {
            var self = this;
            $scope.$watch(function(){return self.atwho},function(atwho_config){
                if (atwho_config) {
                    $element.atwho(self.atwho)
                }
            })

        },
		controllerAs: '$markdown'
	}
}


function TemplateUserHelp($parse, $translate, $timeout, $filter) {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
        controller: function($scope, Classes) {
            var self = this
            this.vars = null;
            this.atwho = null;
            $scope.$watch(function(){return self.object[self.field.client.dataBaseClass]}, function(baseClass){
                if (!baseClass) {
                    return;
                }
                self.field.class_placeholders({classname:baseClass}).then(function(vars){
                    //self.vars = vars
                    var tpltranslate = $filter('tpltranslate')
                    var list = [];
                    for (key in vars) {
                        list.push({
                            varname: key,
                            title: tpltranslate('{{' + vars[key].split(' > ').join('}} > {{') + '}}')
                        })
                    }
                    self.vars = list;

                    self.atwho = {
                        data: list,
                        at: "{",
                        insertTpl: "{{${varname}}}",
                        displayTpl: "<li>${title} <small>${varname}</small></li>",
                        searchKey: "title",
                    }
                })
            })
            
        },
        controllerAs: '$help'
    }
}

function TextFieldLength($parse, $translate, $timeout) {
	return {
		bindToController: {
			field: '<',
            object: '=fieldObject'
		},
		restrict: 'A',
        require:  'ngModel',
        controller: function($element, $scope) {
			
            var self = this;
			
			this.strlength = 0;
			this.minlength = null;
			this.maxlength = null;
			this.remainedlength = 0;
			this.neededlength = 0;
			this.show_sign_counter = false;
			
			if(self.field.client && (self.field.client.minlength || self.field.client.maxlength)){
				self.minlength = self.field.client.minlength;
				self.maxlength = self.field.client.maxlength;
				self.show_sign_counter = true;				
				
				$scope.$watch(function(){return self.object[self.field.name]}, function(text){
                    if (typeof text != 'string') text = '';
                    text = text.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "");  // strip tags
					self.strlength = text.length;
					
					if(self.minlength && (self.minlength - text.length) > 0){
						self.neededlength = self.minlength - text.length;
					}else{
						self.neededlength = 0;
					}
					
					if(self.maxlength && (self.maxlength - text.length) > 0){
						self.remainedlength = self.maxlength - text.length;
					}else if(self.maxlength){
						text.length = self.maxlength;
						self.remainedlength = 0;
					}else{
						self.remainedlength = 0;
					}
				})
				
			}


        },
		controllerAs: '$textFieldLength'
	}
}

angular.module('forms.fields.text', ['hc.marked', 'hljs'])
.directive('markdownTextField', MarkdownTextField)
.directive('templateUserHelp', TemplateUserHelp)
.directive('textFieldLength', TextFieldLength)
.config(['markedProvider', function (markedProvider) {
    markedProvider.setOptions({gfm: true, breaks: true});
}]);